<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <span class="arch">
            <p>Each page she finishes, I remember.</p>
            <br>
<p>If I write it, will she see the words?</p>
           <br>
 <p>I tear a blank page from the book and I write down what I see here. I want to fix this, line by line, the things I remember, the things that my memory holds onto. </p>
            <br>
<p>If I write things down, if I write a word and strike it out, I am making a choice, I am building the city I want.</p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'I Build A City'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
